import React, { useCallback } from "react";
import useMeasure from "react-use-measure";
import { useSpring, animated } from "@react-spring/web";
import cx from "classnames";

import styles from "./transcripts.module.scss";
import { formatTime } from "src/pages/coaching/manage/podcasts/edit/helper";
import { PodcastTranscripts } from "src/types/coaching/podcast";

interface PodcastTranscriptsProps {
  className?: string;
  transcripts: PodcastTranscripts;
  expanded: boolean;
  height: number;
  // eslint-disable-next-line no-unused-vars
  onExpand?: (value: boolean) => void;
}

export const PodcastTranscriptsContainer: React.FC<PodcastTranscriptsProps> = ({
  className, height, transcripts, expanded, onExpand
}) => {
  const [containerRef, containerBounds] = useMeasure();

  //animations
  const [childrenAnimation] = useSpring(
    {
      opacity: expanded ? 1 : 0,
      height: expanded ? "100%" : "0%",
      from: { opacity: 0, height: "0%" },
    },
    [expanded, height],
  );

  const handleExpand = useCallback(() => {
    onExpand?.(!expanded);
  }, [expanded, onExpand]);

  return (
    <div className={cx(styles.transcriptContainer, className, {
      [styles.expanded]: expanded
    })} style={{
      height: expanded ? (height - 32) : 'auto'
    }}>
      <div className={cx(styles.header)} onClick={handleExpand}>
        <span>Read along the podcast</span>
        <i className="paperflite-dropdown" />
      </div>
      <animated.div className={styles.scroller} style={childrenAnimation}>
        {expanded && (
          <div ref={containerRef} className={styles.transcripts} style={{
            height: expanded ? (height - 32) : 'auto'
          }}>
            {(transcripts?.topicSections || []).map((transcript, index) => {
              return (transcript.conversations || []).map(
                (conversation) => {
                  return (
                    <div key={index} className={styles.transcript}>
                      <div className={styles.duration}>
                        {formatTime(conversation.start)}
                      </div>
                      <div className={styles.conversation}>
                        {conversation.text}
                      </div>
                    </div>
                  );
                },
              );
            })}
          </div>
        )}
      </animated.div>
    </div>
  );
};